<template>
    <div class="mb-2 ml-4">
        <b-form-checkbox v-model="isTest" name="check-button" switch @change="$store.dispatch('changeTestData');$router.go(0);">
            <b>{{ isTest ? 'Viewing test data' : 'View test data' }}</b>
        </b-form-checkbox>
    </div>
</template>

<script>
export default {
    name: "TestMode",
    data() {
        return {
            isTest: false
        }
    },
    mounted() {
        this.isTest = this.$store.state.isTest;
    }
}
</script>